
import { useState } from 'react';
import GetInTouchModal from './GetInTouchModal';
import HiringModal from './HiringModal';

export default function Footer() {
  const [showContact, setShowContact] = useState(false);
  const [showHiring, setShowHiring] = useState(false);

  // Optional: safeguard against rendering modals with invalid props
  const handleCloseContact = () => setShowContact(false);
  const handleCloseHiring = () => setShowHiring(false);

  return (
    <>
      <footer className="bg-[#1a1a1a] text-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20 lg:py-28">
          <div className="text-center mb-16">
            <h2
              className="text-4xl lg:text-6xl font-bold text-white leading-tight mb-6"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Let&apos;s create<br />something together.
            </h2>
            <div className="flex items-center justify-center gap-4 mt-8">
              <button
                onClick={() => setShowContact(true)}
                className="px-8 py-3.5 border border-white/30 text-white text-sm font-medium rounded-full hover:bg-white hover:text-gray-900 transition-all cursor-pointer whitespace-nowrap"
              >
                Get in Touch
              </button>
              <button
                onClick={() => setShowHiring(true)}
                className="px-8 py-3.5 bg-white text-gray-900 text-sm font-medium rounded-full hover:bg-gray-200 transition-all cursor-pointer whitespace-nowrap"
              >
                We&apos;re Hiring
              </button>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-12 border-t border-white/10 pt-12">
            <div>
              <h3 className="text-lg font-bold mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>
                CADENCE STUDIOS
              </h3>
              <p className="text-sm text-white/50 leading-relaxed">
                Innovating across film,<br />
                entertainment and tech.
              </p>
            </div>

            <div>
              <h4 className="text-xs font-bold uppercase tracking-[0.15em] text-white/40 mb-5">
                <a href="#about">Follow Us</a>
              </h4>
              <ul className="space-y-3">
                <li>
                  <a
                    href="https://instagram.com"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer flex items-center gap-2"
                  >
                    <i className="ri-instagram-line"></i>
                    Instagram
                  </a>
                </li>
                <li>
                  <a
                    href="https://linkedin.com"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer flex items-center gap-2"
                  >
                    <i className="ri-linkedin-line"></i>
                    LinkedIn
                  </a>
                </li>
                <li>
                  <a
                    href="https://twitter.com"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer flex items-center gap-2"
                  >
                    <i className="ri-twitter-x-line"></i>
                    X / Twitter
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-bold uppercase tracking-[0.15em] text-white/40 mb-5">
                <a href="#about">Quick Links</a>
              </h4>
              <ul className="space-y-3">
                <li>
                  <a href="#work" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer">
                    Our Work
                  </a>
                </li>
                <li>
                  <a href="#about" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer">
                    About Us
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/10 pt-8 mt-12 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-white/30">
            <p>&copy; 2025 Cadence Studios. All rights reserved.</p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white/60 transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </footer>

      {/* Render modals only when they are needed to avoid unnecessary renders */}
      {showContact && (
        <GetInTouchModal isOpen={showContact} onClose={handleCloseContact} />
      )}
      {showHiring && (
        <HiringModal isOpen={showHiring} onClose={handleCloseHiring} />
      )}
    </>
  );
}
